import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { ListaPagamentosComponent } from './components/lista-pagamentos/lista-pagamentos.component';
import { PagamentosService } from '@app/shared/components/api/services/pagamentos.service';
import { DashboardService } from '@app/shared/components/api/services/dashboard.service';
import { DashboardApoioEstadoDto } from '@app/shared/components/api/models/dashboard.model';
import { MoneyPipe } from '@app/shared/pipes/money.pipe';

@Component({
  selector: 'app-pagamentos',
  imports: [
    CommonModule,
    BackButtonComponent,
    ListaPagamentosComponent,
    MoneyPipe
  ],
  providers: [
    PagamentosService,
    DashboardService
  ],
  templateUrl: './pagamentos.component.html',
  styleUrl: './pagamentos.component.scss',
  standalone: true
})
export class PagamentosComponent implements OnInit {
  private readonly pagamentoService = inject(PagamentosService);
  private readonly dashboardService = inject(DashboardService);

  valorTotal: number = 0;
  totalApoios: number = 0;
  totalConfirmados: number = 0;
  totalPendentes: number = 0;
  totalCancelados: number = 0;
  apoiosStats: DashboardApoioEstadoDto[] = [];
  loadingStats: boolean = true;

  ngOnInit(): void {
    this.getApoiosStats();
    this.getValorTotalPagamentos();
  }

  getApoiosStats(): void {
    this.loadingStats = true;
    this.dashboardService.getDashboardApoios().subscribe({
      next: (res) => {
        this.apoiosStats = res?.data || [];
        this.totalApoios = 0;
        this.totalConfirmados = 0;
        this.totalPendentes = 0;
        this.totalCancelados = 0;

        for (const item of this.apoiosStats) {
          this.totalApoios += item.total || 0;
          if (item.estadoApoioENUM === 2 || item.estadoApoio?.toLowerCase() === 'confirmado') {
            this.totalConfirmados = item.total;
          } else if (item.estadoApoioENUM === 1 || item.estadoApoio?.toLowerCase() === 'pendente') {
            this.totalPendentes = item.total;
          } else if (item.estadoApoioENUM === 3 || item.estadoApoio?.toLowerCase() === 'cancelado') {
            this.totalCancelados = item.total;
          }
        }
        this.loadingStats = false;
      },
      error: (err) => {
        console.error('Erro ao carregar estatísticas de apoios:', err);
        this.loadingStats = false;
      }
    });
  }

  getValorTotalPagamentos(): void {
    this.dashboardService.getTotalApoiosConfirmados().subscribe({
      next: (res) => {
        this.valorTotal = res.totalValor || 0;
      },
      error: (err) => {
        console.error('Erro ao carregar total de pagamentos:', err);
      }
    });
  }
}